import { IssuesFilterBar } from "./components/IssuesFilterBar";

export default IssuesFilterBar;